const messagingActions = {
  load: "LOAD",
  clear: "CLEAR",
  message: "MESSAGE",
  notDelivered: "NOT_DELIVERED",
};

export default messagingActions;
